var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['status', _vm.badgeStyle],style:({ height: _vm.height + 'px', width: 'auto' })},[_vm._v(" "+_vm._s(_vm.badgeText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }